import React, { LegacyRef, forwardRef } from 'react';
import cn from 'classnames';
import styles from './Icons.module.scss';
import { SVGProps } from '@repo/utils/types';

// There are a small number of our SVG components that include <defs/>. It is likely
// safe to wrap the <defs/> in a <g/> as we are doing here b/c our wrapper is only
// defining stroke and fill. However, if this causes issues anywhere we can start passing
// defs as a prop.
export default forwardRef(
  (
    {
      width,
      height,
      title,
      className,
      hover = false,
      hoverOpacity = false,
      color = 'primary',
      customColor,
      children,
      // forwardedRef,
      ...props
    }: SVGProps,
    ref: LegacyRef<SVGSVGElement>,
  ) => {
    let gProps: any = { className: styles[color] };

    if (customColor) {
      gProps = { stroke: customColor, fill: customColor };
    }

    if (customColor == 'none') {
      gProps = {};
    }

    return (
      <svg
        className={cn(
          styles.svgCommon,
          className,
          hover && styles.hover,
          hoverOpacity && styles.hoverOpacity,
        )}
        ref={ref}
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
      >
        {title && <title>{title}</title>}
        <g {...gProps}>{children}</g>
      </svg>
    );
  },
);
